import {AlphaLabel} from '@github-ui/lifecycle-labels/alpha'

import styles from './Header.module.css'
import {type MarkdownViewMode, ViewSwitch} from './ViewSwitch'

export interface HeaderProps {
  onChangeViewMode?: (view: MarkdownViewMode) => void
  children?: React.ReactNode
}

/**
 * Header layout container.
 * Important: this is also rendered by error fallbacks so logic that might fail should be kept to an absolute minimum.
 */
export function Header({onChangeViewMode, children}: HeaderProps) {
  return (
    <div className={styles.header}>
      <div style={{flex: 1}}>{children}</div>

      {/* Shipping publicly? Make sure to update the `ErrorFallback` messaging as well. */}
      <AlphaLabel />
      {onChangeViewMode && <ViewSwitch selectedView="hybrid" onViewSelect={onChangeViewMode} />}
    </div>
  )
}

try{ Header.displayName ||= 'Header' } catch {}